import { render, staticRenderFns } from "./addNedit-model.vue?vue&type=template&id=2d31c415&scoped=true&"
import script from "./addNedit-model.vue?vue&type=script&lang=js&"
export * from "./addNedit-model.vue?vue&type=script&lang=js&"
import style0 from "./addNedit-model.vue?vue&type=style&index=0&id=2d31c415&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31c415",
  null
  
)

export default component.exports